var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lead
    ? _c("div", [
        _vm.lead.composed_message &&
        _vm.lead.composed_message.length > _vm.messageMaxLength
          ? _c("div", [
              _vm.messageCollapsed
                ? _c(
                    "div",
                    [
                      _c("nl2br", {
                        attrs: { tag: "p", text: _vm.croppedMessage }
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "read-more-link",
                          on: {
                            click: function($event) {
                              _vm.messageCollapsed = !_vm.messageCollapsed
                            }
                          }
                        },
                        [_vm._v(" Read More ")]
                      )
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("nl2br", {
                        attrs: { tag: "p", text: _vm.lead.composed_message }
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "read-more-link",
                          on: {
                            click: function($event) {
                              _vm.messageCollapsed = !_vm.messageCollapsed
                            }
                          }
                        },
                        [_vm._v(" Read Less ")]
                      )
                    ],
                    1
                  )
            ])
          : _c(
              "div",
              [
                _vm.lead.composed_message
                  ? _c("nl2br", {
                      attrs: { tag: "p", text: _vm.lead.composed_message }
                    })
                  : _vm._e()
              ],
              1
            )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }